import React from 'react';
import Row
			 from 'reactstrap/es/Row';
import Col
			 from 'reactstrap/es/Col';
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Button
}            from 'reactstrap';

class RoleRow extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRole: '',
			isOpen: false,
			selectedID: null,
			disabled: true
		}
	}

	_onSaveClicked = () => {
		var {user} = this.props;
		if (this.state.selectedID) {
			user.ID = this.state.selectedID;
			if (this.props.onSaveHandler) {
				this.props.onSaveHandler(user);
			}
		}
	}

	toggleSelect = () => {
		const {isOpen} = this.state;
		this.setState({isOpen: !isOpen})
	}

	changeSelection = (role) => {
		if (this.props.user.ID === role.ID) {
			this.setState({selectedID: null, disabled: true});
			return
		}
		this.setState({selectedID: role.ID, disabled: false});
	}

	render() {
		const {isOpen, selectedID, disabled} = this.state;
		const currentRole = this.props.roles.find(e => {
			if (selectedID) {
				return e.ID === selectedID;
			}
			return e.ID === this.props.user.ID;
		})

		return (
			<>
				<Row>
					<Col xs={12} md={6}>
						<h3>{this.props.user.InternalUser.Email}</h3>
					</Col>
					<Col xs={12} md={4}>
						<Dropdown isOpen={isOpen} toggle={() => this.toggleSelect()}>
							<DropdownToggle className={`uppercase`} caret>
								{ currentRole.Name || 'Select Role'}
							</DropdownToggle>
							<DropdownMenu>
								<DropdownItem header>Select a Role</DropdownItem>
								{
									this.props.roles.map(r => {
										if (selectedID === r.ID) {
											return <DropdownItem className={`uppercase`}  key={r.ID} disabled onClick={ () => this.changeSelection(r) }>{r.Name}</DropdownItem>
										} else if (!selectedID && currentRole.ID === r.ID) {
											return <DropdownItem className={`uppercase`}  key={r.ID} disabled onClick={ () => this.changeSelection(r) }>{r.Name}</DropdownItem>
										}
										return <DropdownItem className={`uppercase`}  key={r.ID} onClick={ () => this.changeSelection(r) }>{r.Name}</DropdownItem>
									})
								}
							</DropdownMenu>
						</Dropdown>
					</Col>
					<Col xs={12} md={2}>
						<Button disabled={disabled} onClick={this._onSaveClicked}>
							Save
						</Button>
					</Col>
				</Row>
			</>
		)
	}
}

export default RoleRow;